export const WS_DELIVERY_TIME = 'WS Lieferzeit';
